<template>
  <div>
    <input-post
      skipChannelSelection
      v-if="editPostId !== null"
      class="col"
      @cancel="cancelEdit"
      :editPost="editPostId" />

    <div v-else>
      <component
        :is="getListItemType"
        :type="type"
        :title="title"
        :discount="discount"
        :price="price"
        :image="image"
        :selectable="selectable"
        :editable="editable"
        :uid="uid"
        :selected="postSelected"
        :imported="imported"
        @selected="selectBox"
        @deletePost="deletePost" />

    </div>
  </div>
</template>

<script>
import ItemGrid from '@/components/service/postList/ItemGrid'
import ItemList from '@/components/service/postList/ItemList'
import InputPost from '@/components/standard/input/InputPost'

export default {
  components: {
    'item-grid': ItemGrid,
    'item-list': ItemList,
    'input-post': InputPost
  },
  data () {
    return {
      editPostId: null,
      selected: this.postSelected
    }
  },
  methods: {
    cancelEdit () {
      // Remove the editing id...
      this.editPostId = null
    },
    forceSelectionParam (selected) {
      // Just in case if a non boolean value would be passed...
      this.emitSelection(this.type, selected, this.uid, this.getAdvertisable)
    },
    editPost () {
      this.editPostId = this.uid
    },

    emitSelection (type, selected, id, advertisable) {
      this.$emit('selected', {
        type,
        selected,
        id,
        advertisable
      })
    },

    selectBox () {
      if (!this.selectable) return
      this.emitSelection(this.type, !(this.postSelected), this.uid, this.getAdvertisable)
    },
    deletePost () {
      this.$emit('deletePost', {id: this.uid})
    }
  },
  computed: {
    getListItemType () {
      switch (this.displayStyle) {
        case 'list':
          return 'item-list'

        case 'grid':
          return 'item-grid'

        default:
          return null
      }
    },
    getAdvertisable () {
      return {
        __typename: this.type,
        id: this.uid,
        label: this.title,
        url: this.url || ''
      }
    },
    getConnectedClass () {
      let base = 'icon-plain'
      if (this.postSelected) {
        base += ' raised'
      }
      return base
    },
    getOverlayClass () {
      let base = 'position-absolute overlay-bg'
      base += this.postSelected ? ' overlay-shown' : ' overlay-hover'
      return base
    }
  },
  props: {
    displayStyle: {
      type: String,
      required: false,
      default: 'grid'
    },
    deleted: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false
    },
    content: {
      type: String,
      required: false
    },
    discount: {
      type: Number,
      required: false,
      default: null
    },
    price: {
      type: Number,
      required: false,
      default: 0.0
    },
    url: {
      type: String,
      required: false,
      default: ''
    },
    alowEdit: {
      type: Boolean,
      required: false,
      default: true
    },
    selectable: {
      type: Boolean,
      required: false,
      default: false
    },
    postSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    editable: {
      type: Boolean,
      required: false,
      default: false
    },
    datePost: {
      type: String,
      required: false
    },
    dateDiscount: {
      type: String,
      required: false
    },
    uid: {
      required: false
    },
    imported: {
      type: Boolean,
      required: false,
      default: false,
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/service/postList/ItemPost.vue?5784fb12